export default "__VITE_ASSET__ij1CVVaw__"